import React, { useState } from 'react';
import {
  Button,
  Divider,
  Form,
  Input,
  Modal,
  Popover,
  Select,
  Switch,
} from 'antd';
import {
  createMarketHours,
  createPreset,
  createUnderlyingAsset,
  instrumentTypes,
  marketHours,
  REGIONS,
  selectors,
  UnderlyingAsset,
} from 'state';
import { useDispatch, useSelector } from 'react-redux';
import { InfoCircleOutlined } from '@ant-design/icons';
import { auctions_tenors } from '../../../state/app/auctions/types';
import {
  CDS_FREQUECIES,
  TENOR_UNITS,
} from '../../../state/app/repos/constants';

type Props = {
  hide: () => void;
};
const CreatePresetModal: React.FC<Props> = ({ hide }) => {
  const dispatch = useDispatch();
  const [presetName, setPresetName] = useState('');
  const waitingPresets = useSelector(selectors.presetsWaiting);
  return (
    <Modal
      open={true}
      onOk={hide}
      onCancel={hide}
      title={'Create a new assets preset'}
      width={450}
      footer={null}
    >
      <div
        style={{
          // display: 'flex',
          // flexDirection: 'column',
          textAlign: 'right',
        }}
      >
        <Input
          value={presetName}
          onChange={e => {
            setPresetName(e.target.value);
          }}
          placeholder="Preset Name"
        />
        <Button
          loading={waitingPresets}
          style={{ marginTop: 15 }}
          type="primary"
          disabled={!presetName}
          onClick={() => {
            dispatch(createPreset({ preset_name: presetName }));
            // hide();
          }}
        >
          Create
        </Button>
      </div>
    </Modal>
  );
};
export default CreatePresetModal;
